module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-Date_26f0e9cda87fc4c1ff85c239e2fdd0f9.png";